<template>
    <div class="layout" :class="{'dark-mode':dark_mode}">
        <div class="flex">
        <NavComponent />
        <transition name="page">
        <div v-if="animate" class="relative z-10 w-full">
            <slot />
        </div>
        </transition>
        </div>
    </div>
</template>
<script>
import NavComponent from '../Shared/NavAdminComponent.vue'
import FooterComponent from './FooterComponent.vue'
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    components: {NavComponent,FooterComponent},
    data(){
        return{
        animate: false,
        };
    },
    mounted(){
        this.animate = true
    },
    setup(){
        const store=useStore()
        const dark_mode = computed(() => store.state.dark_mode)

        return{
            dark_mode
        }
    }
};
</script>

<style>
    .page-enter-active {
        animation: finished 1s reverse;
    }
    .page-leave-active {
        animation: finished 1s;
    }
    @keyframes finished {
        0% { opacity: 1;}
        100% { opacity: 0;}
    }
</style>